const state = {
    locale: 'en',
};

const getters = {
    getLocale: state => state.locale,
};

const actions = {
    async setLocale({commit}, locale) {
        await commit('setLocale', locale);
    },
};

const mutations = {
    setLocale(state, locale){
        state.locale = locale;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};